/**
 * @Category React Hook function
 * Provide single source to manage application static menus items
 * 
**/


export default function useMenus() {
  return {
    navbarTopRight: [],
    navbarTopLeft: [],
    navbarSideLeft: [
      {
        "to": "/home",
        "label": "Home",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "label": "Gerencial",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
        "role" :["admin"],
        "items": [
          {
            "to": "/dashboardadmin",
            "label": "DashBoard",
            "icon": "pi pi-globe",
            "iconcolor": "",
            "target": "",
          },

          {
            "to": "/apuracao",
            "label": "Apurações",
            "icon": "pi pi-money-bill",
            "iconcolor": "",
            "target": "",
          }
        ]
      },
      {
        "label": "Cadastros",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
        "role" :["admin"],
        "items": [
          {
            "to": "/empresas",
            "label": "Empresas",
            "icon": "pi pi-th-large",
            "iconcolor": "",
            "target": "",
          },
          {
            "to": "/funcionarios",
            "label": "Funcionarios",
            "icon": "pi pi-th-large",
            "iconcolor": "",
            "target": "",
          },
          {
            "to": "/funcoes",
            "label": "Funcoes",
            "icon": "pi pi-th-large",
            "iconcolor": "",
            "target": "",
          },
          {
            "to": "/setores",
            "label": "Setores",
            "icon": "pi pi-th-large",
            "iconcolor": "",
            "target": "",
          },
          {
            "to": "/departamentos",
            "label": "Centro de Custo",
            "icon": "pi pi-th-large",
            "iconcolor": "",
            "target": "",
          }
        ]
      },
      {
        "label": "Produtos / Estoque",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
        "role" :["admin", "company"],
        "items": [

          {
            "to": "/grupos",
            "label": "Agrupamentos",
            "icon": "pi pi-th-large",
            "iconcolor": "",
            "target": "",
            "role" :["admin"]
          },
          {
            "to": "/produtos",
            "label": "Produtos",
            "icon": "pi pi-th-large",
            "iconcolor": "",
            "target": "",
            "role" :["admin", "company"]
          },

          {
            "to": "/GHE",
            "label": "GHE",
            "icon": "pi pi-th-large",
            "iconcolor": "",
            "target": "",
            "role" :["admin"]
          }          
        ]
      },
      {
        "label": "Consulta",
        "icon": "pi pi-user",
        "iconcolor": "",
        "target": "",
        "role" :["admin"],
        "items": [
          {
            "to": "/kardex",
            "label": "Ficha Kardex",
            "icon": "pi pi-th-large",
            "iconcolor": "",
            "target": "",
            "role" :["admin"]
          },
          {
            "to": "/pedidos",
            "label": "Pedidos por Funcionários",
            "icon": "pi pi-th-large",
            "iconcolor": "",
            "target": "",
            "role" :["admin"],
          },
          {
          "to": "/liberacoestotem",
            "label": "Liberação no Totem",
            "icon": "pi pi-th-large",
            "iconcolor": "",
            "target": "",
            "role" :["admin"],
          },
                    {
          "to": "/produtosconsumo",
            "label": "Consumo de Produtos",
            "icon": "pi pi-th-large",
            "iconcolor": "",
            "target": "",
            "role" :["admin"],
          }
          
        ]
      },
      {
        "label": "Administrativo",
        "icon": "pi pi-user",
        "iconcolor": "",
        "target": "",
        "role" :["admin"],
        "items": [
          {
            "to": "/permissions",
            "label": "Permissões",
            "icon": "pi pi-th-large",
            "iconcolor": "",
            "target": "",
            "role" :["admin"]
          },
          {
            "to": "/importdata",
            "label": "Importar Dados",
            "icon": "pi pi-th-large",
            "iconcolor": "",
            "target": "",
            "role" :["admin"]
          }

        ]
      },
    ],
    tipo: [
      { value: "M", label: "Empresa" },
      { value: "F", label: "Cliente" }
    ],
    prodcad: [
      { value: "true", label: "Sim" },
      { value: "false", label: "Não" }
    ],
    active: [
      { value: "true", label: "Ativa" },
      { value: "false", label: "Inativa" }
    ],
    active2: [
      { value: "t", label: "Ativo" },
      { value: "f", label: "Inativo" }
    ],
    sexo: [
      { value: "M", label: "Másculino" },
      { value: "F", label: "Feminino" }
    ],
    active2: [
      { value: "true", label: "Ativo" },
      { value: "false", label: "Inativo" }
    ],
    tipo2: [
      { value: "E", label: "Entrada" },
      { value: "S", label: "Saida" }
    ],
    exportFormats: {
      print: {
        label: 'Print',
        icon: 'pi pi-print',
        type: 'print',
        ext: '',
      },
      pdf: {
        label: 'Pdf',
        icon: 'pi pi-file-pdf',
        type: 'pdf',
        ext: 'pdf',
      },
      excel: {
        label: 'Excel',
        icon: 'pi pi-file-excel',
        type: 'excel',
        ext: 'xlsx',
      },
      csv: {
        label: 'Csv',
        icon: 'pi pi-table',
        type: 'csv',
        ext: 'csv',
      },
    },
  }
}